import React from "react";
import { sliderContentArr } from "./BannerSliderData";
import { Carousel } from "react-bootstrap";
import "./BannerSlider.scss";

const BannerSlider = () => {
  return (
    <section className="Slider_Main">
      <Carousel controls={false}>
        {sliderContentArr.map((state, index) => {
          return (
            <Carousel.Item interval={5000} key={index}>
              <img
                className="d-block w-100"
                src={state.background}
                alt={state.slideNo}
              />
              <aside>
                <span>
                  {state.whitecontent ? (
                    <h1
                      style={{
                        animation: (index === 1 || index === 3) && "none",
                        display: (index === 1 || index === 3) && "block",
                      }}
                    >
                      {state.whitecontent}
                    </h1>
                  ) : (
                    ""
                  )}
                  {state.greencontent ? <h1>{state.greencontent}</h1> : ""}
                </span>
              </aside>
            </Carousel.Item>
          );
        })}
      </Carousel>
    </section>
  );
};

export default BannerSlider;
